import { useSidePanel } from '@dashhudson/dashing-ui/side-panel';
import { computed } from 'vue';

import {
  getHubspotStackRightClass,
  getVisionFabRightClass,
  HUBSPOT_FLOATING_STACK_BASE,
} from '@/components/layout/constants/floatingControls';
import { VISION_AI_PANEL_TYPE, VISION_PANEL_WIDTH_EXPANDED } from '@/components/VisionAi/constants';
import { useHubspotStore } from '@/stores/hubspot';

export function useHubspotFloatingStackLayout(isChatPanelOpen: () => boolean) {
  const {
    visible: sidePanelVisible,
    type: sidePanelType,
    width: sidePanelWidthPx,
  } = useSidePanel();

  const nonChatSidePanelOpen = computed(
    () => sidePanelVisible.value && sidePanelType.value !== VISION_AI_PANEL_TYPE,
  );

  const chatPanelTransformStyle = computed(() => {
    if (!isChatPanelOpen()) {
      return {};
    }
    const w = sidePanelWidthPx.value ?? VISION_PANEL_WIDTH_EXPANDED;
    return { transform: `translateX(-${w}px)` };
  });

  const stackPositionClasses = computed(() => {
    const right = getHubspotStackRightClass(nonChatSidePanelOpen.value);
    return `${HUBSPOT_FLOATING_STACK_BASE} ${right}`;
  });

  return {
    chatPanelTransformStyle,
    stackPositionClasses,
  };
}

export function useVisionFloatingButtonLayout() {
  const hubspotStore = useHubspotStore();
  const {
    visible: sidePanelVisible,
    type: sidePanelType,
    width: sidePanelWidthPx,
  } = useSidePanel();

  const isChatPanelOpen = computed(
    () => sidePanelVisible.value && sidePanelType.value === VISION_AI_PANEL_TYPE,
  );

  const applyNonChatSidePanelOffset = computed(
    () => sidePanelVisible.value && !isChatPanelOpen.value,
  );

  const chatPanelTransformStyle = computed(() => {
    if (!isChatPanelOpen.value) {
      return {};
    }
    const w = sidePanelWidthPx.value ?? VISION_PANEL_WIDTH_EXPANDED;
    return { transform: `translateX(-${w}px)` };
  });

  const buttonPositionClasses = computed(() => {
    const right = getVisionFabRightClass({
      nonChatSidePanelOpen: applyNonChatSidePanelOffset.value,
      hubspotReady: hubspotStore.ready,
      isGdsVersion: hubspotStore.isGdsVersion,
    });
    return `${right} !fixed !bottom-4 !mr-4`;
  });

  return {
    isChatPanelOpen,
    chatPanelTransformStyle,
    buttonPositionClasses,
  };
}
